import { grey } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
	"@global": {
		"*::-webkit-scrollbar": {
			width: "0.4em",
		},
		"*::-webkit-scrollbar-track": {
			"-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
		},
		"*::-webkit-scrollbar-thumb": {
			backgroundColor: "rgba(0,0,0,.1)",
			outline: "1px solid slategrey",
		},
	},
	palette: {
		primary: {
			main: "#212121",
		},
		secondary: {
			main: "#0277bd",
		},
		grayBgColor: {
			main: "#f5f5f5",
		},
	},
	typography: {
		fontFamily: 'Roboto, "Helvetica Neue", Arial, sans-serif',
	},
	components: {
		MuiChip: {
			styleOverrides: {
				root: {
					borderRadius: 3,
				},
			},
		},
		MuiSelect: {
			styleOverrides: {
				root: {
					// borderRadius: "0px 1px 1px 0px",
					border: `1px 1px solid ${grey[100]}`,
				},
			},
		},
	},
});
